const LineBackground = () => {
    return (
        <div className="fixed w-full min-h-[100vh] opacity:10 md:opacity-30 z-[-100]">
            <div className="hidden md:grid grid-cols-12 gap-x-2">
                {Array.from({ length: 12 }).map((_, i) => (
                    <div key={i} className="border-[1px] border-dashed min-h-[100vh]"></div>
                ))}
            </div>
            <div className="grid md:hidden opacity-50 grid-cols-6 gap-x-2">
                {Array.from({ length: 6 }).map((_, i) => (
                    <div key={i} className="border-[1px] border-dashed min-h-[100vh]"></div>
                ))}
            </div>
        </div>
    )
}

export default LineBackground;